import { get, post, put } from '.';

export function GetAppointmentHistory(options = {}) {
	return get<any>("/app/api/appointment_history", options);
}

export function GetAppointments(options = {}) {
	return get<any>("/app/api/appointments", options)
}

export function FindAppointment(vid: string, options = {}) {
	return get<any>(`/app/api/appointments/${vid}`, options)
}

export function CreateAppointment(options = {}) {
	return post<any>("/app/api/appointments", options);
}

export function UpdateAppointment(vid: string, options = {}) {
	return put<any>(`/app/api/appointments/${vid}`, options)
}

export function GetCommunicationCenterCampaign(id: string) {
	return get<any>(`/app/api/appointments/${id}/communication_center_campaign`)
}


export function BulkUpdateAppointmentStatusByFilters(options = {}) {
	return put<any>("/app/api/appointments/bulk_update_status_by_filters", options)
}